// Dependencies
require("grid");

// Styles
require("./formulaire-1-1.scss");

// jQuery
// 
// Must be instanciated before requiring
// jquery-validation
//
var $ = jQuery = require('jquery');

// Form validation demo
if ( $( '.formulaire-1-1__form' ).length > 0 ) {
    require("forms-validation");
    $( '.formulaire-1-1__form' ).validate({

        errorElement: 'span',

        errorClass: 'help-block text-400 text-danger',

        errorPlacement: function ( error, element ) {
            error.insertAfter(element.parent( '.formulaire-1-1__flex' ));
        },

        highlight: function(element) {
            $( element ).parents( '.form-group' ).addClass( 'has-error' );
        },

        unhighlight: function ( element ) {
            $( element ).parents( '.form-group' ).removeClass( 'has-error' );
        },
    });
    $( '.formulaire-1-1__form' ).valid();
}


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/formulaire-1/view-1/index.js
// module id = 199
// module chunks = 0